import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Label } from '../../typography';

var FormFieldLabel =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(FormFieldLabel, _PureComponent);

  function FormFieldLabel() {
    _classCallCheck(this, FormFieldLabel);

    return _possibleConstructorReturn(this, _getPrototypeOf(FormFieldLabel).apply(this, arguments));
  }

  _createClass(FormFieldLabel, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          isAstrixShown = _this$props.isAstrixShown,
          props = _objectWithoutProperties(_this$props, ["children", "isAstrixShown"]);

      return React.createElement(Label, _extends({
        display: "block"
      }, props), children, ' ', isAstrixShown && React.createElement("span", {
        title: "This field is required."
      }, "*"));
    }
  }]);

  return FormFieldLabel;
}(PureComponent);

FormFieldLabel.displayName = "FormFieldLabel";

_defineProperty(FormFieldLabel, "propTypes", _objectSpread({}, Label.propTypes, {
  /**
   * Whether or not to show an asterix after the label.
   */
  isAstrixShown: PropTypes.bool
}));

export { FormFieldLabel as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9mb3JtLWZpZWxkL3NyYy9Gb3JtRmllbGRMYWJlbC5qcyJdLCJuYW1lcyI6WyJSZWFjdCIsIlB1cmVDb21wb25lbnQiLCJQcm9wVHlwZXMiLCJMYWJlbCIsIkZvcm1GaWVsZExhYmVsIiwicHJvcHMiLCJjaGlsZHJlbiIsImlzQXN0cml4U2hvd24iLCJwcm9wVHlwZXMiLCJib29sIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7O0FBQUEsT0FBT0EsS0FBUCxJQUFnQkMsYUFBaEIsUUFBcUMsT0FBckM7QUFDQSxPQUFPQyxTQUFQLE1BQXNCLFlBQXRCO0FBQ0EsU0FBU0MsS0FBVCxRQUFzQixrQkFBdEI7O0lBRXFCQyxjOzs7Ozs7Ozs7Ozs7OzZCQWFWO0FBQUEsd0JBQ3VDLEtBQUtDLEtBRDVDO0FBQUEsVUFDQ0MsUUFERCxlQUNDQSxRQUREO0FBQUEsVUFDV0MsYUFEWCxlQUNXQSxhQURYO0FBQUEsVUFDNkJGLEtBRDdCOztBQUVQLGFBQ0Usb0JBQUMsS0FBRDtBQUFPLFFBQUEsT0FBTyxFQUFDO0FBQWYsU0FBMkJBLEtBQTNCLEdBQ0dDLFFBREgsRUFDYSxHQURiLEVBRUdDLGFBQWEsSUFBSTtBQUFNLFFBQUEsS0FBSyxFQUFDO0FBQVosYUFGcEIsQ0FERjtBQU1EOzs7O0VBckJ5Q04sYTs7QUFBdkJHLGM7O2dCQUFBQSxjLGlDQUtkRCxLQUFLLENBQUNLLFM7QUFFVDs7O0FBR0FELEVBQUFBLGFBQWEsRUFBRUwsU0FBUyxDQUFDTzs7O1NBVlJMLGMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QsIHsgUHVyZUNvbXBvbmVudCB9IGZyb20gJ3JlYWN0J1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJ1xuaW1wb3J0IHsgTGFiZWwgfSBmcm9tICcuLi8uLi90eXBvZ3JhcGh5J1xuXG5leHBvcnQgZGVmYXVsdCBjbGFzcyBGb3JtRmllbGRMYWJlbCBleHRlbmRzIFB1cmVDb21wb25lbnQge1xuICBzdGF0aWMgcHJvcFR5cGVzID0ge1xuICAgIC8qKlxuICAgICAqIENvbXBvc2VzIHRoZSBMYWJlbCBjb21wb25lbnQgYXMgdGhlIGJhc2UuXG4gICAgICovXG4gICAgLi4uTGFiZWwucHJvcFR5cGVzLFxuXG4gICAgLyoqXG4gICAgICogV2hldGhlciBvciBub3QgdG8gc2hvdyBhbiBhc3Rlcml4IGFmdGVyIHRoZSBsYWJlbC5cbiAgICAgKi9cbiAgICBpc0FzdHJpeFNob3duOiBQcm9wVHlwZXMuYm9vbFxuICB9XG5cbiAgcmVuZGVyKCkge1xuICAgIGNvbnN0IHsgY2hpbGRyZW4sIGlzQXN0cml4U2hvd24sIC4uLnByb3BzIH0gPSB0aGlzLnByb3BzXG4gICAgcmV0dXJuIChcbiAgICAgIDxMYWJlbCBkaXNwbGF5PVwiYmxvY2tcIiB7Li4ucHJvcHN9PlxuICAgICAgICB7Y2hpbGRyZW59eycgJ31cbiAgICAgICAge2lzQXN0cml4U2hvd24gJiYgPHNwYW4gdGl0bGU9XCJUaGlzIGZpZWxkIGlzIHJlcXVpcmVkLlwiPio8L3NwYW4+fVxuICAgICAgPC9MYWJlbD5cbiAgICApXG4gIH1cbn1cbiJdfQ==